/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Company,
  CreateGroupAdminInvitationInput,
  CreateGroupMaterialInput,
  GetGroupEvaluationsParams,
  GroupCertificate,
  GroupDetail,
  GroupEvaluations,
  GroupInvitationMutation,
  GroupMaterial,
  GroupMaterialMutation,
  GroupMembershipMutation,
  GroupSelectedCourses,
  GroupWorkshops,
  ListCompaniesParams,
  ListGroupMembershipsParams,
  PaginatedCompanyListItem,
  PaginatedGroupMembership,
  SchemaValidationErrorResponse,
  UpdateGroupDetailInput,
  UpdateGroupMaterialInput,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary List company portal companies
 */
export const listCompanies = (
    params?: MaybeRefOrGetter<ListCompaniesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedCompanyListItem>(
      {url: `/companies`, method: 'GET',
        params, signal
    },
      );
    }




export const getListCompaniesQueryKey = (params?: MaybeRefOrGetter<ListCompaniesParams>,) => {
    return [
    'companies', ...(params ? [params] : [])
    ] as const;
    }


export const getListCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof listCompanies>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListCompaniesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCompanies>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListCompaniesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCompanies>>> = ({ signal }) => listCompanies(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCompanies>>, TError, TData>
}

export type ListCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof listCompanies>>>
export type ListCompaniesQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List company portal companies
 */

export function useListCompanies<TData = Awaited<ReturnType<typeof listCompanies>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListCompaniesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCompanies>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCompaniesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Get company portal group
 */
export const getGroupDetail = (
    companyId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      companyId = toValue(companyId);
groupId = toValue(groupId);

      return axiosClient<GroupDetail>(
      {url: `/companies/${companyId}/groups/${groupId}`, method: 'GET', signal
    },
      );
    }




export const getGetGroupDetailQueryKey = (companyId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>,) => {
    return [
    'companies',companyId,'groups',groupId
    ] as const;
    }


export const getGetGroupDetailQueryOptions = <TData = Awaited<ReturnType<typeof getGroupDetail>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(companyId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupDetail>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetGroupDetailQueryKey(companyId,groupId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGroupDetail>>> = ({ signal }) => getGroupDetail(companyId,groupId, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(companyId) !== null && toValue(companyId) !== undefined && toValue(groupId) !== null && toValue(groupId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGroupDetail>>, TError, TData>
}

export type GetGroupDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getGroupDetail>>>
export type GetGroupDetailQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Get company portal group
 */

export function useGetGroupDetail<TData = Awaited<ReturnType<typeof getGroupDetail>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 companyId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupDetail>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGroupDetailQueryOptions(companyId,groupId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update company portal group
 */
export const updateGroupDetail = (
    companyId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>,
    updateGroupDetailInput?: MaybeRefOrGetter<UpdateGroupDetailInput>,
 signal?: AbortSignal
) => {
      companyId = toValue(companyId);
groupId = toValue(groupId);
updateGroupDetailInput = toValue(updateGroupDetailInput);

      return axiosClient<GroupDetail>(
      {url: `/companies/${companyId}/groups/${groupId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateGroupDetailInput, signal
    },
      );
    }




export const getUpdateGroupDetailMutationKey = () => ['updateGroupDetail'] as const;

export const getUpdateGroupDetailMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGroupDetail>>, TError,UpdateGroupDetailMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateGroupDetail>>, TError,UpdateGroupDetailMutationVariables, TContext> => {

const mutationKey = getUpdateGroupDetailMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateGroupDetail>>, UpdateGroupDetailMutationVariables> = (props) => {
          const {companyId,groupId,data} = props ?? {};

          return  updateGroupDetail(companyId,groupId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateGroupDetailMutationResult = NonNullable<Awaited<ReturnType<typeof updateGroupDetail>>>
    export type UpdateGroupDetailMutationBody = UpdateGroupDetailInput | undefined
    export type UpdateGroupDetailMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type UpdateGroupDetailMutationVariables = {companyId: string;groupId: string;data?: UpdateGroupDetailInput}

    /**
 * @summary Update company portal group
 */
export const useUpdateGroupDetail = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGroupDetail>>, TError,UpdateGroupDetailMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateGroupDetail>>,
        TError,
        UpdateGroupDetailMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateGroupDetailMutationOptions(options), queryClient);
    }
    /**
 * @summary Get company portal certificate page
 */
export const getGroupCertificate = (
    companyId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      companyId = toValue(companyId);
groupId = toValue(groupId);

      return axiosClient<GroupCertificate>(
      {url: `/companies/${companyId}/groups/${groupId}/certificate`, method: 'GET', signal
    },
      );
    }




export const getGetGroupCertificateQueryKey = (companyId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>,) => {
    return [
    'companies',companyId,'groups',groupId,'certificate'
    ] as const;
    }


export const getGetGroupCertificateQueryOptions = <TData = Awaited<ReturnType<typeof getGroupCertificate>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(companyId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupCertificate>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetGroupCertificateQueryKey(companyId,groupId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGroupCertificate>>> = ({ signal }) => getGroupCertificate(companyId,groupId, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(companyId) !== null && toValue(companyId) !== undefined && toValue(groupId) !== null && toValue(groupId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGroupCertificate>>, TError, TData>
}

export type GetGroupCertificateQueryResult = NonNullable<Awaited<ReturnType<typeof getGroupCertificate>>>
export type GetGroupCertificateQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Get company portal certificate page
 */

export function useGetGroupCertificate<TData = Awaited<ReturnType<typeof getGroupCertificate>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 companyId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupCertificate>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGroupCertificateQueryOptions(companyId,groupId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Get group evaluations
 */
export const getGroupEvaluations = (
    companyId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetGroupEvaluationsParams>,
 signal?: AbortSignal
) => {
      companyId = toValue(companyId);
groupId = toValue(groupId);
params = toValue(params);

      return axiosClient<GroupEvaluations>(
      {url: `/companies/${companyId}/groups/${groupId}/evaluations`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetGroupEvaluationsQueryKey = (companyId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetGroupEvaluationsParams>,) => {
    return [
    'companies',companyId,'groups',groupId,'evaluations', ...(params ? [params] : [])
    ] as const;
    }


export const getGetGroupEvaluationsQueryOptions = <TData = Awaited<ReturnType<typeof getGroupEvaluations>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(companyId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetGroupEvaluationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupEvaluations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetGroupEvaluationsQueryKey(companyId,groupId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGroupEvaluations>>> = ({ signal }) => getGroupEvaluations(companyId,groupId,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(companyId) !== null && toValue(companyId) !== undefined && toValue(groupId) !== null && toValue(groupId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGroupEvaluations>>, TError, TData>
}

export type GetGroupEvaluationsQueryResult = NonNullable<Awaited<ReturnType<typeof getGroupEvaluations>>>
export type GetGroupEvaluationsQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Get group evaluations
 */

export function useGetGroupEvaluations<TData = Awaited<ReturnType<typeof getGroupEvaluations>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 companyId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetGroupEvaluationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupEvaluations>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGroupEvaluationsQueryOptions(companyId,groupId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary List company portal admin group memberships
 */
export const listGroupMemberships = (
    companyId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListGroupMembershipsParams>,
 signal?: AbortSignal
) => {
      companyId = toValue(companyId);
groupId = toValue(groupId);
params = toValue(params);

      return axiosClient<PaginatedGroupMembership>(
      {url: `/companies/${companyId}/groups/${groupId}/group_memberships`, method: 'GET',
        params, signal
    },
      );
    }




export const getListGroupMembershipsQueryKey = (companyId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListGroupMembershipsParams>,) => {
    return [
    'companies',companyId,'groups',groupId,'group_memberships', ...(params ? [params] : [])
    ] as const;
    }


export const getListGroupMembershipsQueryOptions = <TData = Awaited<ReturnType<typeof listGroupMemberships>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(companyId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListGroupMembershipsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroupMemberships>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListGroupMembershipsQueryKey(companyId,groupId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGroupMemberships>>> = ({ signal }) => listGroupMemberships(companyId,groupId,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(companyId) !== null && toValue(companyId) !== undefined && toValue(groupId) !== null && toValue(groupId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listGroupMemberships>>, TError, TData>
}

export type ListGroupMembershipsQueryResult = NonNullable<Awaited<ReturnType<typeof listGroupMemberships>>>
export type ListGroupMembershipsQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List company portal admin group memberships
 */

export function useListGroupMemberships<TData = Awaited<ReturnType<typeof listGroupMemberships>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 companyId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListGroupMembershipsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroupMemberships>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListGroupMembershipsQueryOptions(companyId,groupId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Destroy company portal admin group membership
 */
export const destroyGroupMembership = (
    companyId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>,
    membershipId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      companyId = toValue(companyId);
groupId = toValue(groupId);
membershipId = toValue(membershipId);

      return axiosClient<GroupMembershipMutation>(
      {url: `/companies/${companyId}/groups/${groupId}/group_memberships/${membershipId}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyGroupMembershipMutationKey = () => ['destroyGroupMembership'] as const;

export const getDestroyGroupMembershipMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyGroupMembership>>, TError,DestroyGroupMembershipMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyGroupMembership>>, TError,DestroyGroupMembershipMutationVariables, TContext> => {

const mutationKey = getDestroyGroupMembershipMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyGroupMembership>>, DestroyGroupMembershipMutationVariables> = (props) => {
          const {companyId,groupId,membershipId} = props ?? {};

          return  destroyGroupMembership(companyId,groupId,membershipId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyGroupMembershipMutationResult = NonNullable<Awaited<ReturnType<typeof destroyGroupMembership>>>

    export type DestroyGroupMembershipMutationError = ErrorType<SchemaValidationErrorResponse>
    export type DestroyGroupMembershipMutationVariables = {companyId: string;groupId: string;membershipId: string}

    /**
 * @summary Destroy company portal admin group membership
 */
export const useDestroyGroupMembership = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyGroupMembership>>, TError,DestroyGroupMembershipMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyGroupMembership>>,
        TError,
        DestroyGroupMembershipMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyGroupMembershipMutationOptions(options), queryClient);
    }
    /**
 * @summary Extend company portal admin group membership
 */
export const createGroupMembershipExtension = (
    companyId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>,
    membershipId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      companyId = toValue(companyId);
groupId = toValue(groupId);
membershipId = toValue(membershipId);

      return axiosClient<GroupMembershipMutation>(
      {url: `/companies/${companyId}/groups/${groupId}/group_memberships/${membershipId}/extend`, method: 'POST', signal
    },
      );
    }




export const getCreateGroupMembershipExtensionMutationKey = () => ['createGroupMembershipExtension'] as const;

export const getCreateGroupMembershipExtensionMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGroupMembershipExtension>>, TError,CreateGroupMembershipExtensionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createGroupMembershipExtension>>, TError,CreateGroupMembershipExtensionMutationVariables, TContext> => {

const mutationKey = getCreateGroupMembershipExtensionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createGroupMembershipExtension>>, CreateGroupMembershipExtensionMutationVariables> = (props) => {
          const {companyId,groupId,membershipId} = props ?? {};

          return  createGroupMembershipExtension(companyId,groupId,membershipId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateGroupMembershipExtensionMutationResult = NonNullable<Awaited<ReturnType<typeof createGroupMembershipExtension>>>

    export type CreateGroupMembershipExtensionMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type CreateGroupMembershipExtensionMutationVariables = {companyId: string;groupId: string;membershipId: string}

    /**
 * @summary Extend company portal admin group membership
 */
export const useCreateGroupMembershipExtension = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGroupMembershipExtension>>, TError,CreateGroupMembershipExtensionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createGroupMembershipExtension>>,
        TError,
        CreateGroupMembershipExtensionMutationVariables,
        TContext
      > => {
      return useMutation(getCreateGroupMembershipExtensionMutationOptions(options), queryClient);
    }
    /**
 * @summary Create company portal admin invitations
 */
export const createGroupAdminInvitation = (
    companyId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>,
    createGroupAdminInvitationInput?: MaybeRefOrGetter<CreateGroupAdminInvitationInput>,
 signal?: AbortSignal
) => {
      companyId = toValue(companyId);
groupId = toValue(groupId);
createGroupAdminInvitationInput = toValue(createGroupAdminInvitationInput);

      return axiosClient<GroupInvitationMutation>(
      {url: `/companies/${companyId}/groups/${groupId}/invitations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createGroupAdminInvitationInput, signal
    },
      );
    }




export const getCreateGroupAdminInvitationMutationKey = () => ['createGroupAdminInvitation'] as const;

export const getCreateGroupAdminInvitationMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGroupAdminInvitation>>, TError,CreateGroupAdminInvitationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createGroupAdminInvitation>>, TError,CreateGroupAdminInvitationMutationVariables, TContext> => {

const mutationKey = getCreateGroupAdminInvitationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createGroupAdminInvitation>>, CreateGroupAdminInvitationMutationVariables> = (props) => {
          const {companyId,groupId,data} = props ?? {};

          return  createGroupAdminInvitation(companyId,groupId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateGroupAdminInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof createGroupAdminInvitation>>>
    export type CreateGroupAdminInvitationMutationBody = CreateGroupAdminInvitationInput | undefined
    export type CreateGroupAdminInvitationMutationError = ErrorType<SchemaValidationErrorResponse | ValidationError>
    export type CreateGroupAdminInvitationMutationVariables = {companyId: string;groupId: string;data?: CreateGroupAdminInvitationInput}

    /**
 * @summary Create company portal admin invitations
 */
export const useCreateGroupAdminInvitation = <TError = ErrorType<SchemaValidationErrorResponse | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGroupAdminInvitation>>, TError,CreateGroupAdminInvitationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createGroupAdminInvitation>>,
        TError,
        CreateGroupAdminInvitationMutationVariables,
        TContext
      > => {
      return useMutation(getCreateGroupAdminInvitationMutationOptions(options), queryClient);
    }
    /**
 * @summary Get company portal material
 */
export const getGroupMaterial = (
    companyId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      companyId = toValue(companyId);
groupId = toValue(groupId);

      return axiosClient<GroupMaterial>(
      {url: `/companies/${companyId}/groups/${groupId}/material`, method: 'GET', signal
    },
      );
    }




export const getGetGroupMaterialQueryKey = (companyId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>,) => {
    return [
    'companies',companyId,'groups',groupId,'material'
    ] as const;
    }


export const getGetGroupMaterialQueryOptions = <TData = Awaited<ReturnType<typeof getGroupMaterial>>, TError = ErrorType<SchemaValidationErrorResponse>>(companyId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupMaterial>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetGroupMaterialQueryKey(companyId,groupId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGroupMaterial>>> = ({ signal }) => getGroupMaterial(companyId,groupId, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(companyId) !== null && toValue(companyId) !== undefined && toValue(groupId) !== null && toValue(groupId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGroupMaterial>>, TError, TData>
}

export type GetGroupMaterialQueryResult = NonNullable<Awaited<ReturnType<typeof getGroupMaterial>>>
export type GetGroupMaterialQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Get company portal material
 */

export function useGetGroupMaterial<TData = Awaited<ReturnType<typeof getGroupMaterial>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 companyId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupMaterial>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGroupMaterialQueryOptions(companyId,groupId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Create company portal material
 */
export const createGroupMaterial = (
    companyId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>,
    createGroupMaterialInput?: MaybeRefOrGetter<CreateGroupMaterialInput>,
 signal?: AbortSignal
) => {
      companyId = toValue(companyId);
groupId = toValue(groupId);
createGroupMaterialInput = toValue(createGroupMaterialInput);

      return axiosClient<GroupMaterialMutation>(
      {url: `/companies/${companyId}/groups/${groupId}/material`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createGroupMaterialInput, signal
    },
      );
    }




export const getCreateGroupMaterialMutationKey = () => ['createGroupMaterial'] as const;

export const getCreateGroupMaterialMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGroupMaterial>>, TError,CreateGroupMaterialMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createGroupMaterial>>, TError,CreateGroupMaterialMutationVariables, TContext> => {

const mutationKey = getCreateGroupMaterialMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createGroupMaterial>>, CreateGroupMaterialMutationVariables> = (props) => {
          const {companyId,groupId,data} = props ?? {};

          return  createGroupMaterial(companyId,groupId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateGroupMaterialMutationResult = NonNullable<Awaited<ReturnType<typeof createGroupMaterial>>>
    export type CreateGroupMaterialMutationBody = CreateGroupMaterialInput | undefined
    export type CreateGroupMaterialMutationError = ErrorType<SchemaValidationErrorResponse | ValidationError>
    export type CreateGroupMaterialMutationVariables = {companyId: string;groupId: string;data?: CreateGroupMaterialInput}

    /**
 * @summary Create company portal material
 */
export const useCreateGroupMaterial = <TError = ErrorType<SchemaValidationErrorResponse | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGroupMaterial>>, TError,CreateGroupMaterialMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createGroupMaterial>>,
        TError,
        CreateGroupMaterialMutationVariables,
        TContext
      > => {
      return useMutation(getCreateGroupMaterialMutationOptions(options), queryClient);
    }
    /**
 * @summary Update company portal material
 */
export const updateGroupMaterial = (
    companyId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>,
    updateGroupMaterialInput?: MaybeRefOrGetter<UpdateGroupMaterialInput>,
 signal?: AbortSignal
) => {
      companyId = toValue(companyId);
groupId = toValue(groupId);
updateGroupMaterialInput = toValue(updateGroupMaterialInput);

      return axiosClient<GroupMaterialMutation>(
      {url: `/companies/${companyId}/groups/${groupId}/material`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateGroupMaterialInput, signal
    },
      );
    }




export const getUpdateGroupMaterialMutationKey = () => ['updateGroupMaterial'] as const;

export const getUpdateGroupMaterialMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGroupMaterial>>, TError,UpdateGroupMaterialMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateGroupMaterial>>, TError,UpdateGroupMaterialMutationVariables, TContext> => {

const mutationKey = getUpdateGroupMaterialMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateGroupMaterial>>, UpdateGroupMaterialMutationVariables> = (props) => {
          const {companyId,groupId,data} = props ?? {};

          return  updateGroupMaterial(companyId,groupId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateGroupMaterialMutationResult = NonNullable<Awaited<ReturnType<typeof updateGroupMaterial>>>
    export type UpdateGroupMaterialMutationBody = UpdateGroupMaterialInput | undefined
    export type UpdateGroupMaterialMutationError = ErrorType<SchemaValidationErrorResponse>
    export type UpdateGroupMaterialMutationVariables = {companyId: string;groupId: string;data?: UpdateGroupMaterialInput}

    /**
 * @summary Update company portal material
 */
export const useUpdateGroupMaterial = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGroupMaterial>>, TError,UpdateGroupMaterialMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateGroupMaterial>>,
        TError,
        UpdateGroupMaterialMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateGroupMaterialMutationOptions(options), queryClient);
    }
    /**
 * @summary Get selected courses for a company portal group
 */
export const getGroupSelectedCourses = (
    companyId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      companyId = toValue(companyId);
groupId = toValue(groupId);

      return axiosClient<GroupSelectedCourses>(
      {url: `/companies/${companyId}/groups/${groupId}/selected_courses`, method: 'GET', signal
    },
      );
    }




export const getGetGroupSelectedCoursesQueryKey = (companyId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>,) => {
    return [
    'companies',companyId,'groups',groupId,'selected_courses'
    ] as const;
    }


export const getGetGroupSelectedCoursesQueryOptions = <TData = Awaited<ReturnType<typeof getGroupSelectedCourses>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(companyId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupSelectedCourses>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetGroupSelectedCoursesQueryKey(companyId,groupId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGroupSelectedCourses>>> = ({ signal }) => getGroupSelectedCourses(companyId,groupId, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(companyId) !== null && toValue(companyId) !== undefined && toValue(groupId) !== null && toValue(groupId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGroupSelectedCourses>>, TError, TData>
}

export type GetGroupSelectedCoursesQueryResult = NonNullable<Awaited<ReturnType<typeof getGroupSelectedCourses>>>
export type GetGroupSelectedCoursesQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Get selected courses for a company portal group
 */

export function useGetGroupSelectedCourses<TData = Awaited<ReturnType<typeof getGroupSelectedCourses>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 companyId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupSelectedCourses>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGroupSelectedCoursesQueryOptions(companyId,groupId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Get company portal workshops page
 */
export const getGroupWorkshops = (
    companyId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      companyId = toValue(companyId);
groupId = toValue(groupId);

      return axiosClient<GroupWorkshops>(
      {url: `/companies/${companyId}/groups/${groupId}/workshops`, method: 'GET', signal
    },
      );
    }




export const getGetGroupWorkshopsQueryKey = (companyId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>,) => {
    return [
    'companies',companyId,'groups',groupId,'workshops'
    ] as const;
    }


export const getGetGroupWorkshopsQueryOptions = <TData = Awaited<ReturnType<typeof getGroupWorkshops>>, TError = ErrorType<SchemaValidationErrorResponse>>(companyId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupWorkshops>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetGroupWorkshopsQueryKey(companyId,groupId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGroupWorkshops>>> = ({ signal }) => getGroupWorkshops(companyId,groupId, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(companyId) !== null && toValue(companyId) !== undefined && toValue(groupId) !== null && toValue(groupId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGroupWorkshops>>, TError, TData>
}

export type GetGroupWorkshopsQueryResult = NonNullable<Awaited<ReturnType<typeof getGroupWorkshops>>>
export type GetGroupWorkshopsQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Get company portal workshops page
 */

export function useGetGroupWorkshops<TData = Awaited<ReturnType<typeof getGroupWorkshops>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 companyId: MaybeRefOrGetter<string>,
    groupId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupWorkshops>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGroupWorkshopsQueryOptions(companyId,groupId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Get company portal company
 */
export const getCompany = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Company>(
      {url: `/companies/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetCompanyQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'companies',id
    ] as const;
    }


export const getGetCompanyQueryOptions = <TData = Awaited<ReturnType<typeof getCompany>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetCompanyQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompany>>> = ({ signal }) => getCompany(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>
}

export type GetCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getCompany>>>
export type GetCompanyQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Get company portal company
 */

export function useGetCompany<TData = Awaited<ReturnType<typeof getCompany>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanyQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






